module.exports = __webpack_public_path__ + "static/media/5_uebergabe_frei.5ccb4a43.png";